import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { PropalService } from "../service/propal/propal.service";
import { QuoteService } from "../service/quote.service";
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
import { IConfig } from 'libraries/module/formbuilder/forms/searchAirTrip/config';
import { SearchAirTripFormComponent } from 'libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component';
import { ResourceError } from "libraries/service/resource/ResourceError";
import _get from 'lodash-es/get';
import _cloneDeep from 'lodash-es/cloneDeep';
import _size from 'lodash-es/size';
import _filter from 'lodash-es/filter';
import _isObject from 'lodash-es/isObject';
import _set from 'lodash-es/set';
import _forEach from 'lodash-es/forEach';
import * as moment from 'moment';
import { formatDefined, getDateFormat, getDefinedFormat } from 'libraries/changeFormat';
import { WORDING } from "./config/wording";
import { TravellerService } from "../service/traveller/traveller.service";
import { IQuote } from 'libraries/model/air-quote/IQuote';
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { DATE_EXPRESSION_DETAILS, DATE_EXPRESSION_FORM_INTRO } from "libraries/date/date-shared-wording";
import { ILabels } from "libraries/interfaces/ILabels";
import { IExternalApplicationData } from 'libraries/interfaces/IIQBAExternalRelation';
import { CacheQuotedAvailabilityService } from 'app_locobook/service/cache-quoted-availability/cache-quoted-availability.service';
import {
    DictionaryRoutesHostsResourceService
} from "libraries/service/resources/dictionary-routes-hosts/dictionary-routes-hosts-resource.service";
import { IPostAirSearchRequest } from "libraries/interfaces/i-post-air-search-request";
import { tap } from "rxjs/operators";
import { flatMap } from "rxjs/internal/operators";
import { IAirSearchRequest } from 'app_locobook/air-search/air-search.component';
import { IGetAirTripQuotes } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';


/**
 * TODO : TO BE DELETED
 */
@Component({
    selector: 'search-flight-form',
    templateUrl: './searchFlightForm.component.html',
    styles: [`
        .travellerInfo {
            font-size: smaller;
        }

        .resultContainer btn {
            display: block;
            text-align: right;
        }
        field-description {
            position: absolute;
            z-index: 3;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchFlightFormComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild(SearchAirTripFormComponent)
    public searchAirTripForm: SearchAirTripFormComponent;

    public readonly wording: ILabels = WORDING;

    public config: IConfig = {
        'segment': { show: true, add: false, direction: 'Return', context: 'air' },
        'quantity': {
            show: true,
            add: false,
            hasTraveller: true,
            hasRoom: false,
            style: 'inline',
            context: 'air',
            title: this.wording.travellers,
        },
        'price': { show: true },
        'carrier': { show: true },
        'keyword': {
            show: true,
            title: this.wording.includedServices
        },
        'flexibility': {
            show: true,
            title: this.wording.beginFlexibility,
        },
        'locator': {
            show: true,
            title: this.wording.locator,
        },
        'host': {
            show: true,
            title: this.wording.hosts,
        },
        'maxVias': {
            show: true,
            title: this.wording.maxVias,
        },
        'cabin': {
            show: true,
            title: this.wording.cabin,
        },
        'fullServiceCarriersOnly': {
            show: true,
            title: this.wording.fullServiceCarriersOnly,
        }
    };

    // In case of external research, to be modified
    @Input()
    public searchData: any;

    @Input()
    public isFromWatabi: boolean = false;

    @Input()
    public canClose: boolean = false;

    @Input()
    public navigationOrigin: IExternalApplicationData;

    @Input()
    public contextIsModifySegment: boolean;

    @Input()
    public sessionPostOnUpdateBooking: any;

    //emit the quantity of traveller
    @Output()
    public readonly travellerQuantity: EventEmitter<any> = new EventEmitter();

    //emit the quantity of traveller
    @Output()
    public readonly returnToWatabi: EventEmitter<void> = new EventEmitter<void>();

    //emit the form submit
    @Output()
    public readonly submitSearch: EventEmitter<any> = new EventEmitter();

    @Output()
    public readonly close: EventEmitter<void> = new EventEmitter();

    @Output()
    public readonly onError: EventEmitter<string> = new EventEmitter();

    @Output()
    public readonly onDictionaryRoutesHostsError: EventEmitter<string> = new EventEmitter();

    public format = getDateFormat();

    // form field object
    public research: any = {
        "segment":
            [
                {
                    "from": "",
                    "to": "",
                    "date": ""
                },
                {
                    "from": "",
                    "to": "",
                    "date": ""
                }
            ],
        "quantity": {
            "adult": 1,
            "child": 0,
            "infant": 0
        }
    };

    public readonly formDescription: IDescriptionLabels = {
        main: DATE_EXPRESSION_FORM_INTRO,
        detailList: DATE_EXPRESSION_DETAILS
    };
    public showDescription: boolean = false;

    /**
     * @type {Subscription}
     * @private subscription
     */
    private subscription: Subscription;

    private readonly quoteResponse: any;
    // services declarations

    // Get the date format from session storage
    private readonly dateFormat = JSON.parse(sessionStorage.getItem('dateFormat')).momentShort;

    //XXX: TODO: add it to configuration
    // This var define the number of day to add for the auto fill of back date.
    private readonly autoAddDay: number = 10;

    // Var for datepicker
    private minDate: any;
    private maxDate: any; // take the today's date and add 10 years to define the maxDate
    private readonly disableDays: number[] = [];

    private readonly newSearch: boolean = false;
    private inResearch: boolean = false;

    private goDate: string = "";
    private backDate: string = "";

    private goValue: string = "";
    private backValue: string = "";
    private minDateBack: any;

    private readonly toContainPrevMonth: boolean = false;
    private readonly toContainNextMonth: boolean = false;


    private readonly fieldError: any = {
        "goDate": false,
        "backDate": false,
        "adult": false,
        "child": false,
        "infant": false,
        "goFrom": false,
        "goTo": false,
        "backFrom": false,
        "backTo": false
    };

    // private changesBefore: boolean = false;
    private initDone: boolean = false;
    private getHostAvailableSusbscription: Subscription = new Subscription();

    constructor(
        protected readonly propalService: PropalService,
        protected readonly quoteService: QuoteService,
        protected readonly travellerService: TravellerService,
        protected readonly cacheQuotedAvailabilityService: CacheQuotedAvailabilityService,
        protected readonly formBuilderService: FormBuilderService,
        protected readonly dictionaryRoutesHostsService: DictionaryRoutesHostsResourceService,
    ) {
        this.quoteResponse = quoteService.response;
    }

    public ngOnInit(): void {
        if (!this.initDone) {
            this.minDate = moment().format('YYYY-MM-DD');
            this.maxDate = moment().add(10, "y").format('YYYY-MM-DD');
            if (this.searchData && this.searchData.traveller && !this.searchData.quantity) {
                this.searchData.quantity = this.travellerService.getQuantityFromTraveller(this.searchData.traveller);
            }
            // #33720 : commented because linked to this bug
            /*if (this.searchData && this.sessionPostOnUpdateBooking?.agency?.code) {
                this.searchData.locator = this.sessionPostOnUpdateBooking.agency.code
            }*/

            this.subscription = this.formBuilderService
                .submitForm
                .subscribe(
                    (request: any) => {
                        this.search(request);
                    }
                );
        }
        this.initDone = true;
    }

    /**
     * get date from the datepicker and save it
     *
     * @param date
     * @param {number} field
     */
    public setDate(date: any, field: number) {

        this.research.segment[field].date = date;
        if (field === 0) {
            this.goDate = date.format(this.dateFormat);
            this.goValue = this.goDate;
            this.minDateBack = this.research.segment[0].date;
            if (this.research.segment[1].date == "" || this.research.segment[1].date < this.research.segment[0].date) {
                this.autoSetBackDate(date);
            }
        } else if (field === 1) {
            this.backDate = date.format(this.dateFormat);
            this.backValue = this.backDate;
        }


    }

    /** field = 0, 1
     *   parse date like excel format
     *   exemple: 3apr => 03/07/2017 or 03/07/2018 if the minimum date is after the 3rd april 2017
     *
     * @param {number} field
     */
    public parseDate(field: number) {
        let date;

        // FIXME: Surcharge Date object ! delete these lines
        // check if it's for segment 0 or 1
        // define the date from the input and the year by the actual year
        if (field === 0) {
            if (moment(this.goDate, this.dateFormat).format(this.dateFormat) == this.goDate) {
                date = moment(this.goDate, this.dateFormat).set("year", moment().year());
            } else {
                date = moment(this.goDate).set("year", moment().year());
            }
        } else if (field === 1) {
            if (moment(this.backDate, this.dateFormat).format(this.dateFormat) === this.backDate) {
                date = moment(this.backDate, this.dateFormat).set("year", moment().year());
            } else {
                date = moment(this.backDate).set("year", moment().year());
            }
        }


        // check if date is after minDate and parse it with the current year
        if (date.isAfter(this.minDate)) {
            this.research.segment[field].date = date;
            if (field === 0) {
                this.goDate = date.format(this.dateFormat);
                this.goValue = this.goDate;
                if (this.research.segment[1].date === "") {
                    this.autoSetBackDate(date);
                }
            } else if (field === 1) {
                this.backDate = date.format(this.dateFormat);
                this.backValue = this.backDate;
            }
            // else test if the date + 1 year is after minDate and parse it with the current year + 1
        } else if (date.add(1, 'y').isAfter(this.minDate)) {
            this.research.segment[field].date = date;
            if (field === 0) {
                this.goDate = date.format(this.dateFormat);
                this.goValue = this.goDate;
                if (this.research.segment[1].date === "") {
                    this.autoSetBackDate(date);
                }
            } else if (field === 1) {
                this.backDate = date.format(this.dateFormat);
                this.backValue = this.backDate;
            }
        }
    }

    /**
     * Auto upperCase on each changement on destinations input
     *
     * @param {string} input
     * @param {number} fieldCategory
     * @param {string} fieldName
     */
    public upperCase(input: string, fieldCategory: number, fieldName: string) {
        this.research.segment[fieldCategory][fieldName] = input.toUpperCase();

        if (fieldCategory === 0) {
            if (fieldName === "from") {
                this.research.segment[1].to = input.toUpperCase();
            } else if (fieldName === "to") {
                this.research.segment[1].from = input.toUpperCase();
            }
        }
    }

    public returnToWTB(): void{
        this.returnToWatabi.emit();
    }

    public searchAgain() {
        this.search(this.propalService.propalResponse.searchForm || null);
    }

    /**
     * search
     * @param _data
     */
    public search(_data: any): void {
        this.onDictionaryRoutesHostsError.emit(null);
        let data = _data;
        if (data === null) {
            data = this.searchData;
            if (data.segment) {
                for (let segment of data.segment) {
                    segment.begin = new Date(segment.begin.toString() + "z");
                }
            }
        }
        // #31348 keeping travellers when external json is used
        if(this.searchData?.traveller){
            data.traveller = this.searchData.traveller;
        }

        this.quoteService.resetResult();
        this.cacheQuotedAvailabilityService.clearCache();

        this.propalService.propalResponse.data = null;
        this.propalService.propalResponse.message = null;
        this.propalService.propalResponse.searchForm = data;


        //Correct Data from form

        const copy = _cloneDeep(data);

        if (copy.price && copy.price.value) {
            copy.price.value = copy.price.value * 100;
        }
        this.travellerQuantity.emit(data.quantity);
        this.onError.emit(null);
        this.inResearch = true;

        this.getHostAvailableSusbscription = this.dictionaryRoutesHostsService.getHostsAvailable(copy)
            .subscribe({
                next: ((host: string[]) => {
                    if (host?.length) {
                        const dataToSearch = {
                            ...copy,
                            host
                        };
                        this.handleSearch(dataToSearch);
                    } else {
                        this.onDictionaryRoutesHostsError.emit(this.wording.incorrectHost);
                    }
                }),
                error: (error: ResourceError): void => {
                    // #30996 if not list host available and error make search with actual host
                    this.handleSearch(copy);
                    // uncomment next line to see error message in interface
                    // this.onDictionaryRoutesHostsError.emit(error.message);
                }
        });
    }

    private handleSearch(data: IAirSearchRequest): void {
        this.propalService.getPropalData(data, false)
            .subscribe({
                next: (quote: IGetAirTripQuotes): void => {
                    this.propalService.storeResult(quote);
                },
                error: (err: ResourceError): void => {
                    this.onError.emit(err.message);
                    this.propalService.propalResponse.message = err.message;
                }
            });
        this.submitSearch.emit(data);
        this.formBuilderService.emitInfo({ quantity: data.quantity });
    }

    /**
     *   Check all the fields to see if they are OK
     *
     *   return a boolean, true if 1 or more fields are incorrect, false if all fields are good
     */
    public checkFieldError(): boolean {
        let hasError = false;

        // check the go date field
        if (moment.isMoment(this.research.segment[0].date)) {

            if (moment.isMoment(this.research.segment[1].date)) {

                if (this.research.segment[0].date.isAfter(this.research.segment[1].date)) {
                    this.fieldError.goDate = true;
                    hasError = true;
                } else {
                    this.fieldError.goDate = false;
                }

            } else {
                this.fieldError.backDate = true;
                hasError = true;
            }

        } else {
            this.fieldError.goDate = true;
            hasError = true;
        }

        // check the back date field
        if (moment.isMoment(this.research.segment[1].date)) {

            if (moment.isMoment(this.research.segment[0].date)) {

                if (this.research.segment[1].date.isBefore(this.research.segment[0].date)) {
                    this.fieldError.backDate = true;
                    hasError = true;
                } else {
                    this.fieldError.backDate = false;
                }

            } else {
                this.fieldError.backDate = true;
                hasError = true;
            }

        } else {
            this.fieldError.backDate = true;
            hasError = true;
        }

        // check the quantity of travelers

        // adult quantity
        if (this.research.quantity.adult < 1) {
            this.fieldError.adult = true;
            hasError = true;
        } else {
            this.fieldError.adult = false;
        }

        // check adult quantity
        if (this.research.quantity.child < 0) {
            this.fieldError.child = true;
            hasError = true;
        } else {
            this.fieldError.child = false;
        }

        // check infant quantity
        if (this.research.quantity.infant < 0) {
            this.fieldError.infant = true;
            hasError = true;
        } else {
            this.fieldError.infant = false;
        }

        // check if all destination fields are ok

        //check arrival of go travel
        if (this.research.segment[0].to === "" ||
            this.research.segment[0].to === null ||
            this.research.segment[0].to.length > 3) {
            this.fieldError.goTo = true;
            hasError = true;
        } else {
            this.fieldError.goTo = false;
        }

        // check departure of go travel
        if (this.research.segment[0].from === "" ||
            this.research.segment[0].from === null ||
            this.research.segment[0].from.length > 3) {
            this.fieldError.goFrom = true;
            hasError = true;
        } else {
            this.fieldError.goFrom = false;
        }

        // check arrival of return travel
        if (this.research.segment[1].to === "" ||
            this.research.segment[1].to === null ||
            this.research.segment[1].to.length > 3) {
            this.fieldError.backTo = true;
            hasError = true;
        } else {
            this.fieldError.backTo = false;
        }

        // check departure of return travel
        if (this.research.segment[1].from === "" ||
            this.research.segment[1].from === null ||
            this.research.segment[1].from.length > 3) {
            this.fieldError.backFrom = true;
            hasError = true;
        } else {
            this.fieldError.backFrom = false;
        }

        return hasError;
    }

    /**
     *   Reset all the form fields and var that need to be reset
     */
    public resetForm() {
        this.research.segment[0].to = "";
        this.research.segment[0].from = "";
        this.research.segment[0].date = "";

        this.research.segment[1].to = "";
        this.research.segment[1].from = "";
        this.research.segment[1].date = "";

        this.research.quantity.adult = 1;
        this.research.quantity.child = 0;
        this.research.quantity.infant = 0;

        this.inResearch = false;
    }

    public autoSetBackDate(date: any) {
        this.research.segment[1].date = date.add(this.autoAddDay, "d");
        this.backDate = this.research.segment[1].date.format(this.dateFormat);
        this.backValue = this.backDate;
    }


    public getCorrectDate(date: any, field: number): void {

        if (!date || date === "") {
            return;
        }

        if (this.parseFormats(date) === "") {
            return;
        }
        //  let output: string;

        const tempDate = moment(this.parseFormats(date));
        if (!tempDate.isValid()) {
            return;
        }
        //this.research.segment[field].date = moment(this.parseFormats(date));

        if (field === 0) {
            this.goDate = tempDate.format(this.dateFormat);
            this.goValue = this.goDate;
            this.research.segment[0].date = moment(this.parseFormats(date));
            this.minDateBack = tempDate;
            if (this.research.segment[1].date === "" || this.research.segment[1].date < this.research.segment[0].date) {
                this.autoSetBackDate(tempDate);
            }
        } else if (field === 1) {
            this.backDate = tempDate.format(this.dateFormat);
            this.backValue = this.backDate;
            this.research.segment[1].date = moment(this.parseFormats(date));
        }

    }

    /**
     * Parse the date data based on the date format rules
     * Called on change in date data
     * @value - String , user input string (like <[to get first date of the month])
     * @return - String (parsed date data)/ nothing;
     */
    public parseFormats(value: string) {
        let isFound = false;

        const definedFormats = getDefinedFormat(this.format);
        const langBasFormats = formatDefined[this.format];
        // validating and conversion of normal and common formats
        for (const index in definedFormats) {
            for (const eachFormat in definedFormats[index].format) {
                const format = definedFormats[index].format[eachFormat];
                // check if the user input data is mathching any rules
                if (format.test(value.toString())) {
                    isFound = true;
                    return definedFormats[index].equ(value);
                }
            }
            if (isFound) {
                break;
            }
        }
        //validating and conversion of language based formats
        for (const index in langBasFormats) {
            for (const eachFormat in langBasFormats[index].format) {
                const format = langBasFormats[index].format[eachFormat];
                // check if the user input data is mathching any rules
                if (format.test(value)) {
                    isFound = true;
                    return langBasFormats[index].equ(value);
                }
            }
            if (isFound) {
                break;
            }
        }
        if (!isFound) {
            return "";
        }
    }

    public changeSegment(_direction: string): void {
        switch (_direction) {
            case 'Oneway':
                this.reConfig([
                    { 'path': 'segment.direction', 'value': 'Oneway' }
                ]);
                break;
            case 'Return':
                this.reConfig([
                    { 'path': 'segment.direction', 'value': 'Return' }
                ]);
                break;
            case 'Multiple':
                this.reConfig([
                    { 'path': 'segment.direction', 'value': 'Multiple' }
                    , { 'path': 'segment.add', 'value': true }
                ]);
                break;
            default:
                break;
        }
    }


    public emitClose() {
        this.close.emit(null);
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
        this.getHostAvailableSusbscription.unsubscribe();
    }

    public reset(): void {
        this.searchAirTripForm.reset();
    }
    public ngOnChanges(changes: SimpleChanges): void {
        const newSearchData: any = _get(changes, ['searchData', 'currentValue']);
        if (newSearchData) {
            if (!this.initDone) {
                this.ngOnInit();
            }
            if (!newSearchData.quantity) {
                newSearchData.quantity = this.travellerService.getQuantityFromTraveller(newSearchData.traveller);
            }
            //Form cant use range date for now, so get date from begin.min
            (newSearchData.segment || [])
                .filter((segment): boolean => Boolean(segment.begin?.min))
                .forEach((segment): void => { segment.begin = segment.begin.min.split('T')[0]; });
            this.searchData = { ...newSearchData, };
            this.setDirection();

        }
    }

    public toggleDescription(): void {
        this.showDescription = !this.showDescription;
    }

    /** Return the number of travellers by type (Adult / Children / Infant) */
    private mapTravellersToNbrTravellersByType(type: string): number {
        return _size(_filter(this.sessionPostOnUpdateBooking.traveller, { 'type': type }));
    }

    /** Check if is an Object or string and format date in consequence */
    private formatDate(resource: string): string {
        if (_isObject(resource)) {
            return resource;
        } else {
            let backDateReversed = resource.split('-').reverse().join();
            return moment(backDateReversed.replace(/,/g, '-')).format('YYYY-MM-DD');
        }
    }

    /**
     *
     * Re-build Form Config
     */
    private reConfig(_changes: any[]): void {
        const modifConfig: IConfig = _cloneDeep(this.config);

        _forEach(_changes, (_change: any) => {
            _set(modifConfig, _change.path, _change.value);
        });

        this.config = modifConfig;

    }

    private setDirection() {
        //Auto switch Simple/AR/Multiple
        if (this.searchData && this.searchData.segment && this.searchData.segment.length !== 0) {
            if (this.searchData.segment.length === 1) {
                this.changeSegment('Oneway');
            } else if (this.searchData.segment.length === 2) {
                const firstFromValue: string = this.searchData.segment[0].from?.airport ? this.searchData.segment[0].from.airport.iata : this.searchData.segment[0].from;
                const firstToValue: string = this.searchData.segment[0].to?.airport ? this.searchData.segment[0].to.airport.iata : this.searchData.segment[0].to;
                const secondFromValue: string = this.searchData.segment[1].from?.airport ? this.searchData.segment[1].from.airport.iata : this.searchData.segment[1].from;
                const secondToValue: string = this.searchData.segment[1].to?.airport ? this.searchData.segment[1].to.airport.iata : this.searchData.segment[1].to;
                if(firstFromValue === secondToValue && firstToValue === secondFromValue){
                    this.changeSegment('Return');
                }else {
                    this.changeSegment('Multiple');

                }
            } else {
                this.changeSegment('Multiple');
            }
        }
    }
}
